import React from "react";
import { CheckCircle, TrendingUp, Mail } from "react-feather";

export default ({
  label,
  isChecked,
  onChange,
  iconName,
  disabled,
  labelOn = "Vyrill Data",
}) => {
  const icons = {
    check: <CheckCircle size={15} />,
    email: <Mail size={15} />,
    trending: <TrendingUp size={15} />,
  };

  return (
    <div className={`filters-section${disabled ? " disabled" : ""}`}>
      <div className="trending">
        <label>
          {label && <div>{label}:</div>}
          <input
            type="checkbox"
            value="trending"
            checked={isChecked}
            onChange={onChange}
            disabled={disabled}
          />
          <div>
            {isChecked ? "ON" : "OFF"}
            <i>{icons[iconName]}</i>
          </div>{" "}
          - {labelOn}
        </label>
      </div>
    </div>
  );
};
